export const appLinks = {
  apple: 'https://na2.hubs.ly/H07WLYt0',
  android: 'https://na2.hubs.ly/H07WLYz0',
}

/**
 * Direct store listings used by the post-checkout QR codes and download buttons.
 *
 * TODO(dev): replace with the official DIRECT listing URLs, e.g.
 *   ios:     https://apps.apple.com/ca/app/fem-entity/id<APP_ID>
 *   android: https://play.google.com/store/apps/details?id=<PACKAGE_NAME>
 * Until then these fall back to the existing official Fem Entity short links,
 * which redirect to the stores.
 */
export const appStoreListings = {
  ios: appLinks.apple,
  android: appLinks.android,
}

/** HubSpot application form for practitioners joining the network. */
export const practitionerApplicationUrl =
  'https://share-na2.hsforms.com/2lzmKxu4mTDmTD8GYXJU8fA402mcz'

/** HubSpot enquiry form for organizations partnering with Fem Entity. */
export const partnerFormUrl =
  'https://402mcz.share-na2.hsforms.com/2v829hhZ0QQOxnu9LwfXSKQ'

export interface AppTourStep {
  title: string
  description: string
}

export const appTourSteps: AppTourStep[] = [
  {
    title: 'Choose your path',
    description:
      'Whether you are seeking care or providing it, there is a place for you here. Start as a member or apply to join as a practitioner.',
  },
  {
    title: 'Find care that understands your needs',
    description:
      'Take the practitioner matching quiz for personalized results, or browse the full directory and filter by what matters to you.',
  },
  {
    title: 'Connect with a verified practitioner',
    description:
      'Every profile comes from a vetted, trusted network — with experience, specialties, qualifications, and rates shown up front.',
  },
  {
    title: 'Understand your health, and feel in control of it',
    description:
      'Daily mood check-ins, a personal to-do list, and journal prompts help you see a whole picture of your health over time.',
  },
  {
    title: 'From matched to booked, seamlessly',
    description:
      'Pick a time that works, confirm in a few taps, and keep virtual and in-person visits together in one calendar.',
  },
  {
    title: 'Manage your care with confidence',
    description:
      'Upcoming appointments, session details, and one-tap access to join your virtual visit — all on your home screen.',
  },
  {
    title: 'For practitioners: manage and grow your practice',
    description:
      'Your schedule, services, requests, and payments in one place, so you can spend more of your day on care.',
  },
]
